import {strtotime} from '@/library/strtotime';
import {redirectPreserveParams} from '@/library/utils';
import {enrolmentMeta} from '@/router/enrolment';
import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import {ROUTE_REF_PARAM_DEFINITION} from '@/utils/portuna';
import dateHelper from '../utils/portuna/dateHelper';
import {timeTrackerMeta} from './time-tracker';

const EmployeeAssistant      = () => import('../views/employee/components/assistant/EmployeeAssistant.vue');
const EmployeeAssistantIntro = () => import('../views/employee/components/assistant/EmployeeAssistantIntro.vue');
const EmployeeAssistantOutro = () => import('../views/employee/components/assistant/EmployeeAssistantOutro.vue');

// employee
const EmployeeAdminDashboard = () => import('../views/employee/EmployeeAdminDashboard.vue');
const EmployeeDashboard      = () => import('../views/employee/EmployeeDashboard.vue');
const EmployeeHome           = () => import('../views/employee/EmployeeHome.vue');
const EmployeeList           = () => import('../views/employee/EmployeeList.vue');
const EmployeeView           = () => import('../views/employee/EmployeeView.vue');

// const EmployeeAdd  = () => import('../views/employee/EmployeeAdd.vue');
const EmployeeEdit               = () => import('../views/employee/EmployeeEdit.vue');
const EmployeeImport             = () => import('../views/employee/EmployeeImport.vue');
const EmployeeAgendaImport       = () => import('../views/employee/EmployeeAgendaImport.vue');
const EmployeeListTelephone      = () => import('../views/employee/EmployeeListTelephone.vue');
const EmployeeListRepresentative = () => import('../views/employee/EmployeeListRepresentative.vue');
const EmployeeListBirthday       = () => import('../views/employee/EmployeeListBirthday.vue');
const EmployeeListInstructor     = () => import('../views/employee/EmployeeListInstructor.vue');

// entity
const EntityList      = () => import('../views/employee/EntityList.vue');
const EntityView      = () => import('../views/employee/EntityView.vue');
const EntityEdit      = () => import('../views/employee/EntityEdit.vue');
const EntityHierarchy = () => import('../views/employee/EntityHierarchy.vue');

// task
const EmployeeListTask = () => import('../views/employee/EmployeeListTask.vue');

// settings
const EmployeeSettings                        = () => import('../views/employee/EmployeeSettings.vue');
const EmployeeSettingsAddress                 = () => import('../views/employee/settings/EmployeeSettingsAddress.vue');
const EmployeeSettingsStatistic               = () => import('../views/employee/settings/EmployeeSettingsStatistic.vue');
const EmployeeSettingsSuperiorsNotifications  = () => import('../views/employee/settings/EmployeeSettingsSuperiorsNotifications.vue');
const EmployeeSettingsSuperiorsAuthorizations = () => import('../views/employee/settings/EmployeeSettingsSuperiorsAuthorizations.vue');
const EmployeeSettingsAbsences                = () => import('../views/employee/settings/EmployeeSettingsAbsences.vue');
const EmployeeSettingsEducation               = () => import('../views/employee/settings/EmployeeSettingsEducation.vue');
const EmployeeSettingsLicense                 = () => import('../views/employee/settings/EmployeeSettingsLicense.vue');
const EmployeeSettingsSchool                  = () => import('../views/employee/settings/EmployeeSettingsSchool.vue');
const EmployeeSettingsProcurement             = () => import('../views/employee/settings/EmployeeSettingsProcurement.vue');
const EmployeeSettingsSickNote                = () => import('../views/employee/settings/EmployeeSettingsSickNote.vue');
const EmployeeSettingsEnrolment               = () => import('../views/employee/settings/EmployeeSettingsEnrolment.vue');
const EmployeeSettingsVacation                = () => import('../views/employee/settings/EmployeeSettingsVacation.vue');
const EmployeeSettingsTimeTrackerOverview     = () => import('../views/employee/settings/EmployeeSettingsTimeTrackerOverview.vue');
const EmployeeSettingsTimeTracker             = () => import('../views/employee/settings/EmployeeSettingsTimeTracker.vue');
const EmployeeSettingsEmployee                = () => import('../views/employee/settings/EmployeeSettingsEmployee.vue');
const EmployeeSettingsAppInvite               = () => import('../views/employee/settings/EmployeeSettingsAppInvite.vue');
const EmployeeSettingsShiftSchedule           = () => import('../views/employee/settings/EmployeeSettingsShiftSchedule.vue');
const EmployeeSettingsAPIs                    = () => import('../views/employee/settings/EmployeeSettingsAPIs.vue');
const EmployeeSettingsSalary                  = () => import('../views/employee/settings/EmployeeSettingsSalary.vue');

//expandable-vertical-tab-menu
const SettingsList            = () => import('../views/time-tracker/settings/SettingsList.vue');
const SettingsHistoryList     = () => import('../views/time-tracker/settings/SettingsHistoryList.vue');
const SettingsIntranet        = () => import('../views/settings/SettingsIntranet.vue');
const EnrolmentModuleSettings = () => import('../views/enrolment/settings/EnrolmentModuleSettings.vue');
const MailboxList             = () => import('../views/enrolment/settings/mailbox/MailboxList.vue');
const MailTemplateList        = () => import('../views/enrolment/settings/mailTemplate/MailTemplateList.vue');
const FormTemplateList        = () => import('../views/enrolment/settings/webExportTemplate/FormTemplateList.vue');
const ModuleSettingsAutomated = () => import('../views/enrolment/settings/ModuleSettingsAutomated.vue');
const SignatureList           = () => import('../views/enrolment/settings/signature/SignatureList.vue');
const CategoryManagement      = () => import('../components/CategoryManagement.vue');

const WhistleblowerSettings = () => import('../views/whistleblower/settings/WhistleblowerSettings.vue');

// statistic
const EmployeeStatistic             = () => import('../views/employee/statistic/EmployeeStatistic.vue');
const EmployeeStatisticWorkHours    = () => import('../views/employee/statistic/EmployeeStatisticWorkHours.vue');
const EmployeeStatisticBalanceHours = () => import('../views/employee/statistic/EmployeeStatisticBalanceHours.vue');
const EmployeeStatisticAccounting   = () => import('../views/employee/statistic/EmployeeStatisticAccounting.vue');
const EmployeeStatisticAnniversary  = () => import('../views/employee/statistic/EmployeeStatisticAnniversary.vue');
const EmployeeStatisticSalutation   = () => import('../views/employee/statistic/EmployeeStatisticSalutation.vue');

// salary
const EmployeeSalaryList = () => import('../views/employee/salary/EmployeeSalaryList.vue');

let meta: MetaData = {
    module: 'employee',
    assistant: {
        key: 'employee',
        steps: [
            {
                component: EmployeeAssistantIntro,
            },
            {
                title: 'Personal',
                titleIcon: 'support',
                component: EmployeeAssistant,
            },
            {
                component: EmployeeAssistantOutro,
            },
        ],
    },
};

let employee: RouteRecordRaw[] = [
    //<editor-fold desc="employee">
    // home
    {
        path: '/employee',
        alias: [
            '/employee/index/index',
            '/employee/index',
        ],
        name: 'employee-home',
        component: EmployeeHome,
        meta: Object.assign({onlyEmployeeId: true}, meta),
    },
    // dashboard
    {
        path: '/employee/index/dashboard/admin/:entity(\\d+)?',
        name: 'employee-admin-dashboard',
        component: EmployeeAdminDashboard,
        props(route: RouteLocationStringParam)
        {
            return {
                entity: parseInt(route.params.entity) || 0,
            };
        },
        meta,
    },
    {
        path: '/employee/index/dashboard',
        name: 'employee-dashboard',
        component: EmployeeDashboard,
        meta,
    },
    // list
    {
        path: '/employee/employee/list/:type(all|current|future|former|temporary)?',
        name: 'employee-list',
        component: EmployeeList,
        meta,
        alias: [
            '/employee/employee/list/type/main',
        ],
        props(route: RouteLocationStringParam)
        {
            return {
                type: route.params.type || 'current',
            };
        },
    },
    {
        path: '/employee/employee/list/telephone/:search?',
        name: 'employee-list-telephone',
        component: EmployeeListTelephone,
        meta,
        alias: [
            '/employee/employee/list/type/telephone',
        ],
        props(route: RouteLocationStringParam)
        {
            return {
                search: route.params.search || '',
            };
        },
    },
    {
        path: '/employee/employee/list/representative/:withoutRepresentatives(0|1)?/:entity(\\d+)?',
        name: 'employee-list-representative',
        component: EmployeeListRepresentative,
        meta,
        alias: [
            '/employee/employee/list/type/representative',
            '/employee/employee/list/type/representative/without_representatives/:withoutRepresentatives(0|1)?/in_entity/:entity(\\d+)?*',
        ],
        props(route: RouteLocationStringParam)
        {
            return {
                withoutRepresentatives: route.params.withoutRepresentatives || null,
                entity: route.params.entity || null,
            };
        },
    },
    {
        path: '/employee/employee/list/birthday/:search?/entity/:entity(\\d+)?',
        alias: [
            '/employee/employee/list/birthday/:search?/:entity(\\d+)?',
            '/employee/employee/list/type/birthday',
        ],
        name: 'employee-list-birthday',
        component: EmployeeListBirthday,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                search: route.params.search || '',
                entity: parseInt(route.params.entity) || 0,
            };
        },
    },
    {
        path: '/employee/employee/list/instructor/:tab(normal|ihk|unassigned)?',
        name: 'employee-list-instructor',
        component: EmployeeListInstructor,
        meta,
        alias: [
            '/employee/education/instructor/list/tab/:tab?',
            '/employee/education/instructor/list/:wildcard*',
        ],
        props(route: RouteLocationStringParam)
        {
            return {
                tab: route.params.tab || 'normal',
            };
        },
    },

    // view
    {
        path: '/employee/employee/view/:id(\\d+)/:tab([\\w\-]+)?/:new(new)?/' + ROUTE_REF_PARAM_DEFINITION,
        name: 'employee-view',
        component: EmployeeView,
        meta,
        alias: [
            '/employee/employee/view/id/:id(\\d+)/:wildcard*',
        ],
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
                new: !!route.params.new,
            };
        },
    },
    // edit
    {
        path: '/employee/employee/edit/:id(\\d+)/:tab?', // overview
        name: 'employee-edit',
        component: EmployeeEdit,
        meta,
        alias: [
            '/employee/employee/edit/id/:id(\\d+)/:wildcard*',
        ],
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
                tab: parseInt(route.params.id),
            };
        },
    },
    {
        path: '/employee/import/import',
        name: 'employee-import',
        component: EmployeeImport,
        meta,
    },
    {
        path: '/employee/agenda/import',
        name: 'employee-agenda-import',
        component: EmployeeAgendaImport,
        meta,
    },
    //</editor-fold>

    //<editor-fold desc="entity">
    // list
    {
        path: '/employee/entity/list/:search?',
        name: 'entity-list',
        component: EntityList,
        meta,
        alias: [
            '/employee/entity',
        ],
        props(route: RouteLocationStringParam)
        {
            return {
                search: route.params.search || '',
            };
        },
    },
    {
        path: '/employee/entity/hierarchy',
        name: 'entity-hierarchy',
        component: EntityHierarchy,
        meta,
    },
    {
        path: '/employee/employee/task/mine/:state(open|resolved|all)?',
        name: 'employee-task-list-mine',
        component: EmployeeListTask,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                type: 'mine',
                state: route.params.state,
            };
        },
    },
    {
        path: '/employee/employee/task/all/:state(open|resolved|all)?',
        name: 'employee-task-list-all',
        component: EmployeeListTask,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                type: 'all',
                state: route.params.state,
            };
        },
    },
    {
        path: '/employee/employee/task/traced/:state(open|resolved|all)?',
        name: 'employee-task-list-traced',
        component: EmployeeListTask,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                type: 'traced',
                state: route.params.state,
            };
        },
    },
    // view
    {
        path: '/employee/entity/view/:id(\\d+)',
        name: 'entity-view',
        component: EntityView,
        meta,
        alias: [
            '/employee/entity/view/id/:id(\\d+)/:wildcard*',
        ],
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },

    // add
    // {
    //     path: '/employee/entity/edit/:id(\\d+)',
    //     name: 'entity-add',
    //     component: EntityAdd,
    //     meta,
    //     alias: [
    //         '/employee/employee/edit/id/0/:wildcard*',
    //         '/employee/employee/edit/:wildcard*',
    //     ],
    // },

    // edit
    {
        path: '/employee/entity/edit/:id(\\d+)',
        name: 'entity-edit',
        component: EntityEdit,
        meta,
        alias: [
            '/employee/employee/edit/id/:id(\\d+)/:wildcard*',
        ],
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    //</editor-fold>

    //<editor-fold desc="settings">
    {
        path: '/employee/employee/settings/:route(intranet)?',
        name: 'employee-settings',
        component: EmployeeSettings,
        meta,
        alias: [
            '/employee/employee/settings/:wildcard*',
        ],
        children: [
            {
                path: 'address',
                name: 'employee-settings-address',
                component: EmployeeSettingsAddress,
                meta,
            },
            {
                path: 'statistics',
                name: 'employee-settings-statistics',
                component: EmployeeSettingsStatistic,
                meta,
            },
            {
                path: 'superiors',
                name: 'employee-settings-superiors',
                meta,
                redirect: redirectPreserveParams({
                    name: 'employee-settings-superiors-notifications',
                }, ['route']),
                children: [
                    {
                        path: 'notifications',
                        name: 'employee-settings-superiors-notifications',
                        component: EmployeeSettingsSuperiorsNotifications,
                        meta,
                    },
                    {
                        path: 'authorizations',
                        name: 'employee-settings-superiors-authorizations',
                        component: EmployeeSettingsSuperiorsAuthorizations,
                        meta,
                    },
                ],
            },
            {
                path: 'absences',
                name: 'employee-settings-absences',
                component: EmployeeSettingsAbsences,
                meta: timeTrackerMeta,
            },
            {
                path: 'procurement',
                name: 'employee-settings-procurement',
                component: EmployeeSettingsProcurement,
                meta,
            },
            {
                path: 'apis',
                name: 'employee-settings-apis',
                component: EmployeeSettingsAPIs,
                meta,
            },
            {
                path: 'enrolment',
                name: 'employee-settings-enrolment',
                meta: enrolmentMeta,
                redirect: redirectPreserveParams({
                    name: 'employee-settings-enrolment-module-settings',
                }, ['route']),
                children: [
                    {
                        path: 'settings-other',
                        name: 'employee-settings-enrolment-settings-other',
                        component: EmployeeSettingsEnrolment,
                        meta: enrolmentMeta,
                    },
                    {
                        path: 'signature/list',
                        name: 'employee-settings-enrolment-signature-list',
                        component: SignatureList,
                        meta: enrolmentMeta,
                    },
                    {
                        path: 'mail-template/list',
                        name: 'employee-settings-enrolment-mail-template-list',
                        component: MailTemplateList,
                        meta: enrolmentMeta,
                    },
                    {
                        path: 'form-template/list',
                        name: 'employee-settings-enrolment-form-template-list',
                        component: FormTemplateList,
                        meta: enrolmentMeta,
                    },
                    {
                        path: 'mailbox/list',
                        name: 'employee-settings-enrolment-mailbox-list',
                        component: MailboxList,
                        meta: enrolmentMeta,
                    },
                    {
                        path: 'settings/edit-module-settings-automated',
                        name: 'employee-settings-enrolment-module-settings-automated',
                        component: ModuleSettingsAutomated,
                        meta: enrolmentMeta,
                    },
                    {
                        path: 'module-settings',
                        name: 'employee-settings-enrolment-module-settings',
                        component: EnrolmentModuleSettings,
                        meta: enrolmentMeta,
                    },
                ],
            },
            {
                path: 'education',
                name: 'employee-settings-education',
                component: EmployeeSettingsEducation,
                meta,
            },
            {
                path: 'school',
                name: 'employee-settings-school',
                component: EmployeeSettingsSchool,
                meta: timeTrackerMeta,
            },
            {
                path: 'sick-note',
                name: 'employee-settings-sick-note',
                meta: timeTrackerMeta,
                redirect: redirectPreserveParams({
                    name: 'employee-settings-sick-note-settings',
                    params: {
                        tab: 'general',
                    },
                }, ['route']),
                children: [
                    {
                        path: ':tab?',
                        name: 'employee-settings-sick-note-settings',
                        component: EmployeeSettingsSickNote,
                        meta: timeTrackerMeta,
                    },
                ],
            },
            {
                path: 'vacation',
                name: 'employee-settings-vacation',
                meta: timeTrackerMeta,
                redirect: redirectPreserveParams({
                    name: 'employee-settings-vacation-settings',
                    params: {
                        tab: 'general',
                    },
                }, ['route']),
                children: [
                    {
                        path: ':tab?',
                        name: 'employee-settings-vacation-settings',
                        component: EmployeeSettingsVacation,
                        meta: timeTrackerMeta,
                    },
                ],
            },
            {
                path: 'employee',
                name: 'employee-settings-employee',
                redirect: redirectPreserveParams({
                    name: 'employee-settings-employee-settings',
                    params: {
                        tab: 'rights',
                    },
                }, ['route']),
                children: [
                    {
                        path: ':tab?',
                        name: 'employee-settings-employee-settings',
                        component: EmployeeSettingsEmployee,
                        meta: timeTrackerMeta,
                    },
                    {
                        path: 'salary',
                        name: 'employee-settings-salary-index',
                        redirect: redirectPreserveParams({
                            name: 'employee-settings-salary',
                            params: {type: 'base'}
                        }, ['route']),
                        meta: meta,
                        children: [
                            {
                                path: ':type',
                                name: 'employee-settings-salary',
                                component: EmployeeSettingsSalary,
                                meta: meta,
                                props(route: RouteLocationStringParam): { type: string }
                                {
                                    return {type: route.params.type || 'base'};
                                },
                            }
                        ],
                    },
                ],
            },
            {
                path: 'app-invite',
                name: 'employee-settings-app-invite',
                component: EmployeeSettingsAppInvite,
                meta,
            },
            {
                path: 'training/topic/category',
                name: 'employee-settings-training-topic-categories',
                component: CategoryManagement,
                meta,
                props()
                {
                    return {
                        tag: 'div',
                        route: '/employee/training/category',
                    };
                },
            },
            {
                path: 'whistleblower/settings/edit',
                name: 'employee-settings-whistleblower-compliance',
                component: WhistleblowerSettings,
                meta,
                props()
                {
                    return {
                        tag: 'div',
                        route: '/employee/whistleblower/settings',
                    };
                },
            },
            {
                path: 'shift-schedule/settings/edit',
                name: 'employee-settings-shift-schedule',
                component: EmployeeSettingsShiftSchedule,
            },
            {
                path: 'time-tracker',
                name: 'employee-settings-time-tracker',
                redirect: redirectPreserveParams({name: 'employee-settings-time-tracker-system'}, ['route']),
                meta: timeTrackerMeta,
                children: [
                    {
                        path: 'system',
                        name: 'employee-settings-time-tracker-system',
                        redirect: redirectPreserveParams({name: 'employee-settings-time-tracker-overview'}, ['route']),
                        meta: timeTrackerMeta,
                        children: [
                            {
                                path: 'overview',
                                name: 'employee-settings-time-tracker-overview',
                                component: EmployeeSettingsTimeTrackerOverview,
                                meta: timeTrackerMeta,
                            },
                            {
                                path: 'module/:tab?',
                                name: 'employee-settings-time-tracker-module-settings',
                                component: EmployeeSettingsTimeTracker,
                                props(route: RouteLocationStringParam): { type: string }
                                {
                                    return {type: 'module', tab: route.params.tab || 'clock'};
                                },
                                meta: timeTrackerMeta,
                            },
                        ],
                    },
                    {
                        path: 'settings',
                        name: 'employee-settings-time-tracker-settings',
                        redirect: redirectPreserveParams({name: 'employee-settings-time-tracker-settings-general'}, ['route']),
                        meta: timeTrackerMeta,
                        children: [
                            {
                                path: 'general/:tab?',
                                name: 'employee-settings-time-tracker-settings-general',
                                component: EmployeeSettingsTimeTracker,
                                props(route: RouteLocationStringParam): { type: string }
                                {
                                    return {type: 'general', tab: route.params.tab || 'general'};
                                },
                                meta: timeTrackerMeta,
                            },
                        ],
                    },
                    {
                        path: 'employee',
                        name: 'employee-settings-time-tracker-employee',
                        redirect: redirectPreserveParams({name: 'employee-settings-time-tracker-employee-settings', params: {tab: 'system'}}, ['route']),
                        meta: timeTrackerMeta,
                        children: [
                            {
                                path: 'settings/:tab?/:mode(current|future)?',
                                name: 'employee-settings-time-tracker-employee-settings',
                                component: EmployeeSettingsTimeTracker,
                                props(route: RouteLocationStringParam): { type: string }
                                {
                                    return {
                                        type: 'employee',
                                        tab: route.params.tab || 'system',
                                        mode: route.params.mode || 'current',
                                    };
                                },
                                meta: timeTrackerMeta,
                            },
                        ],
                    },
                    {
                        path: 'other',
                        name: 'employee-settings-time-tracker-other',
                        meta: timeTrackerMeta,
                        redirect: redirectPreserveParams({name: 'employee-settings-time-tracker-other-settings-list'}, ['route']),
                        children: [
                            {
                                path: ':type(employee|entity)?',
                                name: 'employee-settings-time-tracker-other-settings-list',
                                component: SettingsList,
                                meta: timeTrackerMeta,
                                props(route: RouteLocationStringParam)
                                {
                                    return {
                                        type: route.params.type || 'employee',
                                    };
                                },
                            },
                            {
                                path: 'history/:type(employee|entity|global|resource)?',
                                name: 'employee-settings-time-tracker-settings-history-list',
                                component: SettingsHistoryList,
                                meta: timeTrackerMeta,
                                props(route: RouteLocationStringParam)
                                {
                                    return {
                                        type: route.params.type || 'employee',
                                    };
                                },
                            },
                            {
                                path: 'license',
                                name: 'employee-settings-license',
                                component: EmployeeSettingsLicense,
                                meta,
                            },
                            {
                                path: 'other',
                                name: 'employee-settings-time-tracker-other-settings',
                                component: EmployeeSettingsTimeTracker,
                                props(): { type: string }
                                {
                                    return {type: 'other', tab: 'other'};
                                },
                                meta: timeTrackerMeta,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'settings/edit',
                name: 'employee-settings-settings-intranet',
                component: SettingsIntranet,
            },
        ],
    },
    //</editor-fold>

    //<editor-fold desc="statistics">

    {
        path: '/employee/statistic/:date(\\d{4}-\\d{2}-\\d{2})?',
        name: 'employee-statistic',
        component: EmployeeStatistic,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                date: route.params.date ? route.params.date : dateHelper('Y-m-01', strtotime('last month')),
            };
        },
    },
    {
        path: '/employee/statistic/hours/:year?',
        name: 'employee-statistic-work-hours',
        component: EmployeeStatisticWorkHours,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                year: route.params.year ? parseInt(route.params.year) : parseInt(dateHelper('Y') as string),
            };
        },
    },
    {
        path: '/employee/statistic/balance-hours/:year?',
        name: 'employee-statistic-balance-hours',
        component: EmployeeStatisticBalanceHours,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                year: route.params.year ? parseInt(route.params.year) : parseInt(dateHelper('Y') as string),
            };
        },
    },
    {
        path: '/employee/statistic/accounting/:date(\\d{4}-\\d{2}-\\d{2})?/:entity(\\d+)?',
        name: 'employee-statistic-accounting',
        component: EmployeeStatisticAccounting,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                date: route.params.date || dateHelper('Y-m-d'),
                entity: route.params.entity ? parseInt(route.params.entity) : 0,
            };
        },
    },
    {
        path: '/employee/statistic/anniversary',
        name: 'employee-statistic-anniversary',
        component: EmployeeStatisticAnniversary,
        meta,
    },
    {
        path: '/employee/statistic/salutation/:date(\\d{4}-\\d{2}-\\d{2})?/:entity(\\d+)?/:clients([\\d\\|\\-]+)?',
        name: 'employee-statistic-salutation',
        component: EmployeeStatisticSalutation,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                date: route.params.date || dateHelper('Y-m-d'),
                entity: Number(route.params.entity) || 0,
                // "|" instead of "-" cause -1 is an option
                clients: (route.params.clients || '').split('|').map(Number).filter(number => number),
            };
        },
    },
    //</editor-fold>

    {
        path: '/employee/salary/list/:date(\\d{4}-\\d{2}-\\d{2})?',
        name: 'employee-salary-list',
        component: EmployeeSalaryList,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                date: route.params.date || dateHelper('Y-m-d'),
            };
        },
    },
];

export default employee;
